require('./hireCardOpenYoungStep3.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const { HireContactDataForm } = require('components/hireContactDataForm/hireContactDataForm');
const { OpenYoungPersonalDataForm } = require('components/openYoungPersonalDataForm/openYoungPersonalDataForm');
const { OpenYoungTutorTypeSelect } = require('components/openYoungTutorTypeSelect/openYoungTutorTypeSelect');

// @ constants
const { THIRD_STEP } = require('constants/index');

class HireCardOpenYoungStep3 extends React.Component {

    constructor(props) {
        super(props);

        this.handleAddAccount = this.handleAddAccount.bind(this);
    }

    handleAddAccount() {
        const {
            addAccount,
            loadUserContactData,
            resetContactData,
            resetPersonalData,
        } = this.props;
        
        resetContactData();
        resetPersonalData();
        loadUserContactData('hireCardOpenYoungContact');
        addAccount();
    }

    buildRadioButtonJuniorAccounts() {
        const {
            handleAccountChange,
            immHireCardOpenYoung,
            immOpenYoungProfiles
        } = this.props;
        
        const immStep3 = immHireCardOpenYoung.getIn(['steps', THIRD_STEP]);
        let content;

        if (immOpenYoungProfiles.get('byOrder').size > 0) {
            let buttonAddAccount;
            let radioButtons = [];

            immOpenYoungProfiles.getIn(['byOrder']).forEach((accountId, index) => {
                const immAccount = immOpenYoungProfiles.getIn(['byId', accountId]);
                if (!immAccount.get('panNumber') && immAccount.get('isUnder18')) {
                    radioButtons.push(
                        <RadioButton
                            key={index}
                            label={immAccount.get('name')}
                            value={accountId}
                            overrideLabel={true}
                        />
                    );
                }
            });
            
            if (radioButtons.length > 0) {
                if (!immStep3.get('addingNewJuniorAccount')) {
                    buttonAddAccount = (
                        <div className="hire-card-open-young-step-three__button-add-other-child">
                            <OKButton   
                                leftIcon="icon-agregar"
                                modifier="ghost"
                                onClick={this.handleAddAccount}
                            >
                                <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_newOpenYoung" />
                            </OKButton>
                        </div>
                    );
                }
                content = (
                    <div className="hire-card-open-young-step-three__add-other-child">
                        <FormattedText
                            className="hire-card-open-young__step-title"
                            value="hireCardOpenYoung-hireCardOpenYoung_step3TitleCardUses"
                        />
                        <RadioButtonGroup
                            name="selectApprovedCredit"
                            idPrefix="selectApprovedCredit"
                            selectedValue={`${immStep3.get('juniorAccountId')}`}
                            onChange={handleAccountChange}
                        >
                            {radioButtons}
                        </RadioButtonGroup>
                        {buttonAddAccount}
                    </div>
                );
            }
        }
        return content;
    }

    render() {
        const {
            handleTutorCheckboxChange,
            immHireCardOpenYoung,
            immHireContactData,
            immOpenYoungProfileDetails,
            immOpenYoungProfiles,
            immOpenYoungPersonalData,
            immOpenYoungTutorType,
        } = this.props;

        const immStep3 = immHireCardOpenYoung.getIn(['steps', THIRD_STEP]);
        const tutorCheckbox = immStep3.get('tutorCheckbox');
        const tutorCheckboxErrorState = tutorCheckbox.get('isDirty') && !tutorCheckbox.get('isValid');
        const tutorLabel = (
            <React.Fragment>
                <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_declaration" /> 
                &nbsp;
                <OKLink
                    modifier="emphasize"
                    target="_blank"
                    to={formatText('hireCardOpenYoung-hireCardOpenYoung_declarationLinkUrl')}
                >
                    <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_declarationLink" />
                </OKLink>
            </React.Fragment>
        );
        const tutorErrorMessage = formatText('hireCardOpenYoung-hireCardOpenYoung_declarationError');
        let content = <LoadingSection />;
        let contentForms;
        let accountsRadioButton;

        if (!immOpenYoungProfiles.get('isFetching')) {
            accountsRadioButton = this.buildRadioButtonJuniorAccounts();

            if (immOpenYoungProfileDetails.get('isFetching')) {
                contentForms = <LoadingSection />;
            } else if (!!immStep3.get('juniorAccount') || !accountsRadioButton || immStep3.get('addingNewJuniorAccount')) {
                const readOnlyForms = !!accountsRadioButton && !immStep3.get('addingNewJuniorAccount');
                const isCountryOfBirthInvalid = immOpenYoungPersonalData.get('isCountryOfBirthInvalid');
                contentForms = (
                    <React.Fragment>
                        <h3>
                            <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_relationshipSelectTitle" />
                        </h3>
                        <OpenYoungTutorTypeSelect
                            immOpenYoungTutorType={immOpenYoungTutorType}
                        />
                        <h3>
                            <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_personalDataFormTitle" />
                        </h3>
                        <OpenYoungPersonalDataForm
                            immOpenYoungPersonalData={immOpenYoungPersonalData}
                            readOnly={readOnlyForms}
                            validateDocument={true}
                            isCountryOfBirthInValid={isCountryOfBirthInvalid}
                        />
                        <h3>
                            <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_contactDataFormTitle" />
                        </h3>
                        <HireContactDataForm
                            immHireContactData={immHireContactData}
                            mobileReadOnly={true}
                            readOnly
                            instanceId="hireCardOpenYoungContact"
                        />
                    </React.Fragment>
                );
            }

            content = (
                <React.Fragment>
                    {accountsRadioButton}
                    {contentForms}
                    <div className="hire-card-open-young-step-three__checkbox-container">
                        <OKCheckbox
                            idName="checkbox-tutor"
                            errorState={tutorCheckboxErrorState}
                            errorMessage={tutorErrorMessage}
                            label={tutorLabel}
                            onChange={handleTutorCheckboxChange}
                            value={tutorCheckbox.get('value')}
                        />
                    </div>
                </React.Fragment>
            );
        }

        return (
            <article className="hire-card-open-young-step-three">
                {content}
            </article>
        );
    }
}

HireCardOpenYoungStep3.propTypes = {
    addAccount: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    handleTutorCheckboxChange: PropTypes.func.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireCardOpenYoung: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immOpenYoungProfileDetails: PropTypes.object.isRequired,
    immOpenYoungProfiles: PropTypes.object.isRequired,
    immOpenYoungTutorType: PropTypes.object.isRequired,
    loadUserContactData: PropTypes.func.isRequired,
    resetContactData: PropTypes.func.isRequired,
    resetPersonalData: PropTypes.func.isRequired,
};

module.exports = HireCardOpenYoungStep3;
